export { default } from './SkeletonFeaturedDestinations';
